export default "/images/framework/WordWalletCht.60934ef5.svg?60934ef5";